@for (item of miniFlowSavedItems; track item) {
  @if (item?.item_id === item_id) {
    <app-question-mini-flow-controller
      [question]="childQuestion"
      [max_item_id]="item_id"
      [item_id]="item_id"
      [edit]="edit"
      (questionAnswer)="submitResponse($event)">
    </app-question-mini-flow-controller>
  }
  @if (item?.item_id !== item_id) {
    <div class="question-saved" [id]="'item_' + item?.item_id">
      <div class="question-saved__content">
        @if (item?.icon) {
          <div class="question-saved__icon">
            <img [src]="item?.icon" class="icon" alt="">
          </div>
        }
        <div class="question-saved__name">
          <h6 class="font-16">{{item?.description_1}}</h6>
          <small *ngif="showPremium">{{ isNaN(item?.description_2) ? item?.description_2 : globalQuestionService?.accounting?.formatMoney( item?.description_2 )}}</small>
          <div class="question-saved__actions d-none d-md-block">
            @if (item?.allow_edit === '1') {
              <a href="javascript:void(0);" (click)="editItem(item?.item_id)" class="text-link">Edit</a>
            }
            @if (item?.allow_delete === '1') {
              <span>|</span>
            }
            @if (item?.allow_delete === '1') {
              <a href="javascript:void(0);"
                (click)="globalQuestionService.setSelectedMiniFlowItem(item?.questions[0]?.product_class_id, item?.item_id)"
              class="action-remove text-link">Remove</a>
            }
          </div>
        </div>
        <div class="question-saved__cost d-none d-md-block">
          <p *ngif="showPremium"><strong>{{globalQuestionService?.accounting?.formatMoney(item?.premium)}}</strong> /{{globalQuestionService?.currency?.display_freq}}</p>
        </div>
      </div>
      <!-- mobile actions and cost tray-->
      <div class="question-saved__tray d-md-none">
        <div class="question-saved__actions">
          @if (item?.allow_edit === '1') {
            <a href="javascript:void(0);" (click)="editItem(item?.item_id)" class="text-link">Edit</a>
          }
          @if (item?.allow_delete === '1') {
            <span>|</span>
          }
          @if (item?.allow_delete === '1') {
            <a href="javascript:void(0);"
              (click)="globalQuestionService.setSelectedMiniFlowItem(item?.questions[0]?.product_class_id, item?.item_id)"
            class="action-remove text-link">Remove</a>
          }
        </div>
        <div class="question-saved__cost">
          <p><strong>{{globalQuestionService?.accounting?.formatMoney(item?.premium)}}</strong> /{{globalQuestionService?.currency?.display_freq}}</p>
        </div>
      </div>
    </div>
  }
}
<!-- <div class="question-panel question-panel--mini">
<div id="question-add-container">
  <a href="javascript:;"  data-scrollto="" (click)="opemModalForm()" class="question-panel__add" id="question-add-btn">
    <div class="button-control">
      <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another</strong>
    </div>
  </a>
</div>
</div> -->


@if (max_item_id && !edit) {
  <app-question-mini-flow-controller
    [question]="childQuestion"
    [max_item_id]="max_item_id"
    (disableButtonChange)="disableButton.emit($event)"
    (questionAnswer)="submitResponse($event)">
  </app-question-mini-flow-controller>
}


